import { FormattedMessage } from 'react-intl';
import React from 'react';
import cx from 'classnames';
import ParagraphProps from '../../types/ParagraphType';

/**
 * ## Display a paragraph with open-sans font.
 *
 * @param {children} React.ReactNode
 * @param {justify} boolean - Does the text needs to be justified ?
 * @returns React.ReactNode
 */
function Paragraph({
  justify,
  css,
  translationId,
  translationValues,
}: ParagraphProps) {
  return (
    <p
      data-testid="paragraph"
      className={cx({ 'text-justify': justify }, css, 'open-sans-font')}
    >
      <FormattedMessage id={translationId} values={translationValues} />
    </p>
  );
}
export default Paragraph;
